import { useState } from "react";
import LayoutComponent from "components/layout/LayoutComponent";
import DashboardPage from "features/Dashboard/page/dashboard/DashboardPage";
import ForgotPasswordPage from "features/forgot-password/page/forgot-password/ForgotPasswordPage";
import LoginPage from "features/login/page/login/LoginPage";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ReportsPage from "features/Reports/ReportsPage";
import AnalyticsPage from "features/Analytics/AnalyticsPage";
import ConfigPage from "features/Config/ConfigPage";
import UploadPage from "features/Upload/UploadPage";
import InternalDashboardPage from "features/internal-dashboard/InternalDashboardPage";
import ClientManagementPage from "features/client-management/ClientManagementPage";
import { SnackbarProvider } from "components/snackbar/SnackbarContext";
import ClientManagementDetailPage from "features/client-management/ClientManagementDetailPage";
import storage from "services/storage";
import AnalyticsTransactionListPage from "features/Analytics/AnalyticsTransactionListPage";
import { Helmet } from "react-helmet";

function App() {
  const [layoutAction, setLayoutAction] = useState();
  const [layoutTitle, setLayoutTitle] = useState();
  const [type, setType] = useState(storage.getItem("type"));
  const [role, setRole] = useState(storage.getItem("role"));
  const [subscrType, setSubscrType] = useState(storage.getItem("subscrType"));

  return (
    <div>
      {/* Google tag (gtag.js) */}
      {process.env.REACT_APP_ENVIRONMENT === "staging" ? (
        <Helmet>
          <script
            async
            src='https://www.googletagmanager.com/gtag/js?id=G-SFD0NZR1Y8'
          ></script>
          <script>
            {`window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-SFD0NZR1Y8');`}
          </script>
        </Helmet>
      ) : (
        <Helmet>
          <script
            async
            src='https://www.googletagmanager.com/gtag/js?id=G-S695JKMTS7'
          ></script>
          <script>
            {`window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'G-S695JKMTS7');`}
          </script>
        </Helmet>
      )}
      <SnackbarProvider>
        <BrowserRouter>
          <Routes>
            <Route index element={<LoginPage setType={setType} />} />
            <Route path='forgot-password' element={<ForgotPasswordPage />} />
            <Route path='*' element={<Navigate to='/' />} />

            <Route
              element={
                <LayoutComponent
                  action={layoutAction}
                  title={layoutTitle}
                  role={role}
                  subscrType={subscrType}
                  setRole={setRole}
                  setSubscrType={setSubscrType}
                />
              }
            >
              {type === "ADMIN" ? (
                // INTERNAL Route
                <>
                  <Route
                    path='dashboard'
                    element={
                      <InternalDashboardPage
                        setLayoutAction={setLayoutAction}
                      />
                    }
                  />
                  {role?.includes("ADMIN") && (
                    <Route
                      path='upload'
                      element={<UploadPage setLayoutAction={setLayoutAction} />}
                    />
                  )}
                  <Route
                    path='client-management'
                    element={
                      <ClientManagementPage setLayoutAction={setLayoutAction} />
                    }
                  />
                  <Route
                    path='client-management/:id'
                    element={
                      <ClientManagementDetailPage
                        setLayoutAction={setLayoutAction}
                        setLayoutTitle={setLayoutTitle}
                      />
                    }
                  />
                </>
              ) : (
                // EXTERNAL Route
                <>
                  <Route
                    path='dashboard'
                    element={
                      <DashboardPage setLayoutAction={setLayoutAction} />
                    }
                  />
                  <Route
                    path='reports'
                    element={<ReportsPage setLayoutAction={setLayoutAction} />}
                  />
                  {subscrType === "PRO" && (
                    <>
                      <Route
                        path='analytics'
                        element={
                          <AnalyticsPage
                            setLayoutAction={setLayoutAction}
                            setLayoutTitle={setLayoutTitle}
                          />
                        }
                      />
                      <Route
                        path='analytics/transactions'
                        element={
                          <AnalyticsTransactionListPage
                            setLayoutAction={setLayoutAction}
                            setLayoutTitle={setLayoutTitle}
                          />
                        }
                      />
                      <Route
                        path='config'
                        element={
                          <ConfigPage
                            setLayoutTitle={setLayoutTitle}
                            setLayoutAction={setLayoutAction}
                          />
                        }
                      />
                    </>
                  )}
                </>
              )}
            </Route>
          </Routes>
        </BrowserRouter>
      </SnackbarProvider>
    </div>
  );
}

export default App;
